export default __webpack_public_path__ + "static/media/honk-app-icon.f1491c4a.jpg";